import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3a.7.7 0 0 1 .7.7v1c1.212.145 2.07.664 2.637 1.343.648.775.863 1.697.863 2.335a.7.7 0 1 1-1.4 0 2.36 2.36 0 0 0-.537-1.438c-.38-.454-1.05-.88-2.263-.88-1.013 0-1.704.32-2.139.739a2.177 2.177 0 0 0-.661 1.58c0 .551.197 1.007.667 1.47.496.49 1.283.973 2.433 1.518 1.167.554 2.136 1.083 2.81 1.727.712.683 1.09 1.491 1.09 2.528 0 1.108-.454 2.058-1.232 2.721-.61.52-1.394.842-2.268.953V20.3a.7.7 0 1 1-1.4 0v-1.009c-2.29-.328-3.5-2.238-3.5-3.67a.7.7 0 1 1 1.4 0c0 .844.876 2.319 2.8 2.319.883 0 1.588-.261 2.06-.663.463-.394.74-.953.74-1.655 0-.633-.205-1.082-.659-1.517-.494-.472-1.275-.92-2.44-1.473-1.184-.56-2.147-1.124-2.818-1.786-.697-.688-1.083-1.49-1.083-2.468 0-.943.36-1.883 1.089-2.586.598-.578 1.413-.967 2.411-1.09V3.7A.7.7 0 0 1 12 3Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=DollarsIcon24.js.map